import { ref } from 'vue'
import type { Agenda } from '@agenda-selector/types/agenda.type'
import { ContentType } from '@agenda-selector/constants'
import type { CollectionPlayer } from '@collection-player/types/collection-player.type'
import { FileContentTypeEnum } from '@openapi'

export function useContentWarning() {
  const isWarningVisible = ref(false)

  const isAnyCollectionContentNonPresentation = (item: CollectionPlayer) =>
    item.groups.find((group) =>
      group.slides.find(
        (item) => !(FileContentTypeEnum.PDF === item.file.content_type && item.file.metadata?.pptx_data),
      ),
    )

  const isAnyContentNonPresentation = (agenda: Agenda) =>
    !!agenda.groups.find((group) =>
      group.items.find((item) => {
        if (item.type === ContentType.Collection) {
          return isAnyCollectionContentNonPresentation(item.content)
        } else {
          return true
        }
      }),
    )

  const validateAgendaContent = (agenda: Agenda) => {
    if (isAnyContentNonPresentation(agenda)) {
      displayWarning()
    }
  }

  const validateCollectionPlayerContent = (item: CollectionPlayer) => {
    if (isAnyCollectionContentNonPresentation(item)) {
      displayWarning()
    }
  }

  const reopenWarning = () => {
    isWarningVisible.value = false

    setTimeout(() => {
      isWarningVisible.value = true
    }, 0)
  }

  const displayWarning = () => {
    if (isWarningVisible.value) {
      reopenWarning()
    } else {
      isWarningVisible.value = true
    }
  }

  return {
    isWarningVisible,
    validateAgendaContent,
    validateCollectionPlayerContent,
  }
}
